import * as Actions from './WebinarsActions';
import { normalizeWebinars } from './WebinarsUtils';
import { getDifference, getUnion, sortArrayBasedOnArray } from '../../Utils/ArrayUtils';

const initialState = {
  fetching: false,
  webinars: {
    byKey: {},
    allKeys: [],
    deSelectedKeys: [],
    filteredKeys: [],
    filteredSelectedWebinarKeys: []
  },
  filter: {
    searchString: '',
    fromTime: null,
    toTime: null
  },
  error: null
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case Actions.GET_WEBINARS_REQUEST: {
      return {
        ...state,
        filter: {
          ...state.filter,
          fromTime: action.payload.fromTime,
          toTime: action.payload.toTime
        },
        fetching: true,
        error: null
      };
    }
    case Actions.GET_WEBINARS_SUCCESS: {
      const webinarsList = action.payload.webinarsList || [];
      const { allKeys, byKey } = normalizeWebinars(webinarsList);
      const { searchString = state.filter.searchString } = action.payload;
      const newFilteredKeys = getFilteredWebinarKeys(allKeys, byKey, searchString);

      const deSelect = getDifference(newFilteredKeys, state.webinars.filteredSelectedWebinarKeys);
      const select = getDifference(newFilteredKeys, deSelect);
      return {
        ...state,
        fetching: false,
        webinars: {
          ...state.webinars,
          byKey,
          allKeys,
          filteredKeys: newFilteredKeys,
          deSelectedKeys: deSelect,
          filteredSelectedWebinarKeys: select
        }
      };
    }
    case Actions.GET_WEBINARS_FAILURE:
      return { ...state, ...initialState, fetching: false, error: action.error };
    case Actions.TOGGLE_WEBINAR: {
      const { webinarKey, isSelected } = action.payload;
      const { deSelectedKeys: existingDeSelectedKeys, allKeys, filteredKeys } = state.webinars;
      const newDeSelectedKeys = isSelected
        ? existingDeSelectedKeys.filter(key => key !== webinarKey)
        : sortArrayBasedOnArray([...existingDeSelectedKeys, webinarKey], allKeys);
      const newFilterSelectedWebinarKeys = getDifference(filteredKeys, newDeSelectedKeys);
      return {
        ...state,
        webinars: {
          ...state.webinars,
          deSelectedKeys: newDeSelectedKeys,
          filteredSelectedWebinarKeys: newFilterSelectedWebinarKeys
        }
      };
    }
    case Actions.TOGGLE_ALL_WEBINARS: {
      const { deSelectedKeys, filteredKeys } = state.webinars;
      const newDeSelectedKeys = action.payload.isSelected
        ? getDifference(deSelectedKeys, filteredKeys)
        : getUnion(deSelectedKeys, filteredKeys);
      const newFilterSelectedWebinarKeys = getDifference(filteredKeys, newDeSelectedKeys);
      return {
        ...state,
        webinars: {
          ...state.webinars,
          deSelectedKeys: newDeSelectedKeys,
          filteredSelectedWebinarKeys: newFilterSelectedWebinarKeys
        }
      };
    }
    case Actions.FILTER_WEBINARS: {
      const { searchString = state.filter.searchString } = action.payload;
      const { allKeys, byKey, deSelectedKeys } = state.webinars;
      const filteredKeys = getFilteredWebinarKeys(allKeys, byKey, searchString);
      const newFilterSelectedWebinarKeys = getDifference(filteredKeys, deSelectedKeys);
      return {
        ...state,
        webinars: {
          ...state.webinars,
          searchString: searchString,
          filteredKeys: filteredKeys,
          filteredSelectedWebinarKeys: newFilterSelectedWebinarKeys
        }
      };
    }
    default:
      return state;
  }
};

let getFilteredWebinarKeys = function(allWebinarKeys, webinarsMap, searchString) {
  if (searchString === null) {
    return [...allWebinarKeys];
  }
  return allWebinarKeys.filter(webinarKey => {
    const webinar = webinarsMap[webinarKey] || {};
    const { name } = webinar;
    return searchString && name ? name.toUpperCase().includes(searchString.toUpperCase()) : true;
  });
};



// WEBPACK FOOTER //
// ./src/Reducks/Webinars/WebinarsReducer.js